<template>
	<el-container direction="vertical">
		<Header :member="member" logo="logo_info" :defaultActive="defaultActive"></Header>
		<router-view></router-view>
		<Footer v-if="!showFoot"></Footer>
	</el-container>
</template>

<script>
	import {
		getCookie
	} from '@/utils/app'
	import Cookie from 'js-cookie'

	import Header from '@/components/header'
	import Footer from '@/components/footer'

	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				defaultActive: {
					path: '',
					pid: 0
				},
				member: {},
				searchForm: {
					source: '',
					wd: ''
				},
        showFoot :false
			}
		},
		created() {
			this.defaultActive.path = this.$route.path
			if (this.$route.params.pid) {
				this.defaultActive.pid = this.$route.params.pid.replace('.html', '')
			}
      
      this.showFoot = this.$route.path.indexOf('/paper/detail') == 0 && this.$ismobile
      
      console.log('this.showFoot',this.showFoot)
		},
		mounted() {
			this.member = getCookie('member')
      
		},
		methods: {
			signOut: function() {
				Cookie.set('member', base64encode(JSON.stringify({})), {
					expires: 0
				})
				this.getMember()
				this.$router.push('/login/')
			}
		},
		watch: {
			$route: function(e) {
				this.defaultActive.path = e.path
				if (this.$route.params.pid) {
					this.defaultActive.pid = this.$route.params.pid.replace('.html', '')
				}
			}
		}
	}
</script>

<style scoped>
  .el-header>>>.el-input-group .el-input-group__prepend {
    border-left: 2px solid #bb0000;
    border-top: 2px solid #bb0000;
    border-bottom: 2px solid #bb0000;
  }

  .el-header>>>.el-input-group .el-input__inner {
    border-top: 2px solid #bb0000;
    border-bottom: 2px solid #bb0000;
    border-left: 0;
    border-right: 0;
    width: 365px;
  }

  .el-header>>>.el-input-group .el-input-group__append {
    border-right: 2px solid #bb0000;
    border-top: 2px solid #bb0000;
    border-bottom: 2px solid #bb0000;
  }

  .el-header>>>.el-input-group .el-input-group__append {
    background: #bb0000;
  }

  .el-header>>>.menu {
    background: #bb0000;
  }

  .el-footer::before {
    content: '';
    height: 2px;
    background: #bb0000;
  }
</style>